import { Sheet } from "common/sheet";
import { resourcesRoot } from "from-start/scene/resources";
import * as R from "ramda";
import { Background } from "./background";
import { Button } from "./button";
import { Mum } from "./mum";
import { Title } from "./title";
export const soundFileName = "사운드.m4a";
export const soundFilePath = toPath(soundFileName);
export function toPath(fileName) {
    return `${resourcesRoot}/8-wreath/${fileName}`;
}
export const resourcePaths = [
    ...R.compose(R.chain((n) => [`sheet${n}.png`, `sheet${n}.json`]), R.range)(0, 2),
].map((name) => toPath(name));
export async function loadSheets() {
    return await Promise.all(R.compose(R.map((n) => Sheet.load(toPath(`sheet${n}.png`), toPath(`sheet${n}.json`))), R.range)(0, 2));
}
export { Button, Title, Background, Mum };
//# sourceMappingURL=resources.js.map